import styled from "styled-components";
interface IProps {
  color?: React.CSSProperties["color"];
  background?: React.CSSProperties["background"];
}

export const Styles = styled.div<IProps>`
  input {
    background: ${(props) =>
      props.background ? props.background + " !important" : ""};
    color: ${(props) => (props.color ? props.color + " !important" : "")};
  }
`;
